import {RootState} from '../store';

export const getVisibleLogout = (state: RootState) => state.auth.visibleLogout;
export const getVisibleChangePassword = (state: RootState) =>
  state.auth.visibleChangePassword;
export const getLoading = (state: RootState) => state.auth.loading;
export const getIsAuthenticated = (state: RootState) =>
  state.auth.isAuthenticated;
export const getDirection = (state: RootState) => state.auth.dircation;
export const getInitialUrl = (state: RootState) => state.auth.initialUrl;
export const getMyPermissions = (state: RootState) => state.auth.myPermissions;

export const getMyProfile = (state: RootState) => state.auth.myProfile;
export const getIsMyProfileLoading = (state: RootState) =>
  state.auth.isMyProfileLoading;
